export const FRONT_WALL_FLOOR_COUNT_LABEL = 'claim.declaration.external_damages.form.front_wall.floor_count.title';
export const FRONT_WALL_WIDENESS_LABEL = 'claim.declaration.external_damages.form.front_wall.wideness.title';
